// Package Dependencies
import { call, put, takeLatest } from 'redux-saga/effects'
// Additional Dependencies
import axios from '../../utility/Axios'
// Action Dependencies
import {
  LIST_AUTHORITY_REQUEST,
  listAuthoritySuccess,
  listAuthorityFailure
} from '../../actions/Authority/Authority'

// Function Handle List Authority
function* handleListAuthority(data) {
  try {
    // Define Query Parameters
    const parameter = {
      version: '1.0.0'
    }
    // Define Endpoint
    const endpoint = `/authority/${parameter.version}`

    // List Authority Request
    const response = yield call(axios.get_request, endpoint)
    // List Authority Success
    yield put(listAuthoritySuccess(response.data))
  } catch (error) {
    // List Authority Error
    yield put(listAuthorityFailure(error))
  }
}

// Export
export const AuthoritySaga = [
  takeLatest(LIST_AUTHORITY_REQUEST, handleListAuthority),
]